/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Withdrawal_Until_DeliveryInputs */

const en_withdrawal_until_delivery = /** @type {(inputs: Withdrawal_Until_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can withdraw until 14 days after you receive it`)
};

const pl_withdrawal_until_delivery = /** @type {(inputs: Withdrawal_Until_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Możesz odstąpić do 14 dni od otrzymania przesyłki`)
};

/**
* | output |
* | --- |
* | "You can withdraw until 14 days after you receive it" |
*
* @param {Withdrawal_Until_DeliveryInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const withdrawal_until_delivery = /** @type {((inputs?: Withdrawal_Until_DeliveryInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Withdrawal_Until_DeliveryInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_withdrawal_until_delivery(inputs)
	return en_withdrawal_until_delivery(inputs)
});